<template>
    <div class="white-bg down-sort-box">
        <h2 class="side-title">下载排行</h2>
        <ul>
            <li><i></i><a href="html/16.html" title="腾讯QQ下载v9.1.1.24953 最新版" target="_blank">腾讯QQ下载v9.1.1.24953
                最新版</a></li>
            <li><i></i><a href="html/94.html" title="Smart QQ下载 2.0 官方版" target="_blank">Smart QQ下载 2.0 官方版</a>
            </li>
            <li><i></i><a href="html/90.html" title="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版" target="_blank">腾讯tim(QQ简洁版)
                v2.3.1.20994 官方最新版</a></li>
            <li><i></i><a href="html/91.html" title="营销qq2019最新版 v2.21.2927 官方版" target="_blank">营销qq2019最新版
                v2.21.2927 官方版</a></li>
            <li><i></i><a href="html/92.html" title="Wine QQ国际版 UbuntuKylin版 官方版" target="_blank">Wine QQ国际版
                UbuntuKylin版 官方版</a></li>
            <li><i></i><a href="html/93.html" title="企业QQ2019电脑版 v2.0 最新版" target="_blank">企业QQ2019电脑版 v2.0
                最新版</a></li>
            <li><i></i><a href="html/95.html" title="腾讯QQ下载v9.1.1.24953 最新版" target="_blank">腾讯QQ下载v9.1.1.24953
                最新版</a></li>
            <li><i></i><a href="html/96.html" title="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版" target="_blank">腾讯tim(QQ简洁版)
                v2.3.1.20994 官方最新版</a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "DownSort"
    }
</script>

<style scoped>

</style>